import { defineComponent as _defineComponent } from 'vue'
interface Props {
	dense?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpDetailsGroup',
  props: {
    dense: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})